import { OCPI_HUB_ROUTES } from 'shared/consts/routes/ocpi-hub';
import { MenuAddButton } from 'shared/ui/section-menu';

export function AddButton() {
  return (
    <MenuAddButton
      path={OCPI_HUB_ROUTES.ADD_OCPI_HUB}
      requiredRights={[
        {
          controller: 'OcpiHubs',
          right: 'Write',
        },
      ]}
    />
  );
}
